	<div class="row mb-2 captch-main-div">
		<div class="captcha-inline mb-2" [class.disabled-container]="isLoad">
			<p class="mb-0 me-2 captcha-text">{{ code }}</p>
			<input class="form-control input-field border-2 captch-input-field" type="number" [(ngModel)]="captch_input" (blur)="onDataEntered($event)" (input)="clearCaptchErr()" (wheel)="disableScroll($event)" tabindex="1"/>
			<a href="javascript:void(0)" class="cpt-btn" (click)="playCaptcha()">
				<img src="../../../../assets/Images/speaker.svg" alt="Play Captcha">
			</a>
			<a href="javascript:void(0)" class="cpt-btn reload" (click)="createCaptcha(); clearCaptchErr();">
				<img src="../../../../assets/Images/reset.svg" alt="Reload Captcha">
			</a>
		</div>
	</div>
	<span class="text-danger small mt-1">{{invalidCaptchaErr}}</span>

<!-- <div class="captchaform">
	<canvas id="captcahCanvas" width="316" height="80" class="canvasSize"></canvas>
	<div class="captchaAnswerinput">
			<input class="form-control bg-transparent" type="text" [(ngModel)]="captch_input" (blur)="onDataEntered($event)" tabindex="1" style="border: 7px solid rgb(219 244 255); border-radius: 7px; width:235px; padding:2px;" />
		<div class="captchaRefresh">
			<a href="javascript:void(0)" class="cpt-btn speaker" (click)="playCaptcha()">🔈</a>
			<a href="javascript:void(0)" class="cpt-btn reload refresh-arrow" (click)="createCaptcha()">&#x21bb;</a>
			<! -- <input type="button" value="Check" (click)="checkCaptcha()" /> -- >
		</div>
	</div>
</div> -->
